import React from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const responsiveSettings = [
  {
    breakpoint: 800,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      duration: 8000,
    },
  },
  {
    breakpoint: 700,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      duration: 5000,
    },
  },
  {
    breakpoint: 500,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      duration: 3500,
    },
  },
];

const GalleryComponent = () => {
  return (
    <div className="gallery-container">
      <p
        style={{
          textAlign: "center",
          color: "white",
          marginBottom: "2em",
          font: "600 18px Clash Display, -apple-system, Roboto, Helvetica",
        }}
      >
        BUILDING THE PROJECT
      </p>
      <Slide indicators={true} responsive={responsiveSettings}>
        <div className="sld">
          <img src={require("./res/bts (1).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (2).jpg")} alt="cat" />
        </div>
        <div className="sld">
          {" "}
          <img src={require("./res/bts (3).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (4).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (5).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (6).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (7).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (8).jpg")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (13).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (10).JPG")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (11).jpg")} alt="cat" />
        </div>
        <div className="sld">
          <img src={require("./res/bts (12).JPG")} alt="cat" />
        </div>
      </Slide>
      <style jsx>{`
        .sld {
          text-align: center;
          font-size: 30px;
          margin: 0px 20px;
        }

        .sld img {
          height: 80%;
          width: 80%;
          object-fit: contains;
        }

        .gallery-container {
          max-width: 100%;
        }
      `}</style>
    </div>
  );
};

export default GalleryComponent;
